import React from "react";
import { SocialIcon } from "./icon-link-styles";

export const IconLink = ({ url, icon, color, size, noPadding }) => {
  if (url) {
    return (
      <a href={url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
        <SocialIcon icon={icon} $color={color} $size={size} $noPadding={noPadding} />
      </a>
    );
  }
  return <SocialIcon icon={icon} $color={color} $size={size} $noPadding={noPadding} />;
};
